export const governanceABI = [
    {
        payable: false,
        stateMutability: 'nonpayable',
        type: 'constructor',
        inputs: [{ name: 'test', internalType: 'bool', type: 'bool' }],
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'approver', internalType: 'address', type: 'address', indexed: true }],
        name: 'ApproverSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'concurrentProposals', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ConcurrentProposalsSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'destination', internalType: 'address', type: 'address', indexed: true },
            { name: 'functionId', internalType: 'bytes4', type: 'bytes4', indexed: true },
            { name: 'threshold', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ConstitutionSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'dequeueFrequency', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'DequeueFrequencySet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'executionStageDuration', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ExecutionStageDurationSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'hash', internalType: 'bytes32', type: 'bytes32', indexed: true },
            { name: 'approver', internalType: 'address', type: 'address', indexed: false },
        ],
        name: 'HotfixApproved',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'hash', internalType: 'bytes32', type: 'bytes32', indexed: true }],
        name: 'HotfixExecuted',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'timeDelta', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'HotfixExecutionTimeWindowSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'hash', internalType: 'bytes32', type: 'bytes32', indexed: true },
            { name: 'executionLimit', internalType: 'uint256', type: 'uint256', indexed: true },
        ],
        name: 'HotfixPrepared',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'hash', internalType: 'bytes32', type: 'bytes32', indexed: true }],
        name: 'HotfixRecordReset',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'hash', internalType: 'bytes32', type: 'bytes32', indexed: true },
            { name: 'whitelister', internalType: 'address', type: 'address', indexed: false },
        ],
        name: 'HotfixWhitelisted',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'minDeposit', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'MinDepositSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'previousOwner', internalType: 'address', type: 'address', indexed: true },
            { name: 'newOwner', internalType: 'address', type: 'address', indexed: true },
        ],
        name: 'OwnershipTransferred',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'baselineQuorumFactor', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ParticipationBaselineQuorumFactorSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'baselineUpdateFactor', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ParticipationBaselineUpdateFactorSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'participationBaseline', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ParticipationBaselineUpdated',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'participationFloor', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ParticipationFloorSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256', indexed: true }],
        name: 'ProposalApproved',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256', indexed: true },
            { name: 'timestamp', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ProposalDequeued',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256', indexed: true }],
        name: 'ProposalExecuted',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256', indexed: true }],
        name: 'ProposalExpired',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256', indexed: true },
            { name: 'proposer', internalType: 'address', type: 'address', indexed: true },
            { name: 'transactionCount', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'deposit', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'timestamp', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ProposalQueued',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256', indexed: true },
            { name: 'account', internalType: 'address', type: 'address', indexed: true },
            { name: 'revokedUpvotes', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ProposalUpvoteRevoked',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256', indexed: true },
            { name: 'account', internalType: 'address', type: 'address', indexed: true },
            { name: 'upvotes', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ProposalUpvoted',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256', indexed: true },
            { name: 'account', internalType: 'address', type: 'address', indexed: true },
            { name: 'value', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'weight', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ProposalVoteRevoked',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256', indexed: true },
            { name: 'account', internalType: 'address', type: 'address', indexed: true },
            { name: 'yesVotes', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'noVotes', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'abstainVotes', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ProposalVoteRevokedV2',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256', indexed: true },
            { name: 'account', internalType: 'address', type: 'address', indexed: true },
            { name: 'value', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'weight', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ProposalVoted',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256', indexed: true },
            { name: 'account', internalType: 'address', type: 'address', indexed: true },
            { name: 'yesVotes', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'noVotes', internalType: 'uint256', type: 'uint256', indexed: false },
            { name: 'abstainVotes', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ProposalVotedV2',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'queueExpiry', internalType: 'uint256', type: 'uint256', indexed: false }],
        name: 'QueueExpirySet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [
            { name: 'referendumStageDuration', internalType: 'uint256', type: 'uint256', indexed: false },
        ],
        name: 'ReferendumStageDurationSet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address', indexed: true }],
        name: 'RegistrySet',
    },
    {
        type: 'event',
        anonymous: false,
        inputs: [{ name: 'council', internalType: 'address', type: 'address', indexed: true }],
        name: 'SecurityCouncilSet',
    },
    { payable: true, stateMutability: 'payable', type: 'fallback' },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'approver',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'sender', internalType: 'address', type: 'address' },
            { name: 'blsKey', internalType: 'bytes', type: 'bytes' },
            { name: 'blsPop', internalType: 'bytes', type: 'bytes' },
        ],
        name: 'checkProofOfPossession',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'concurrentProposals',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'dequeueFrequency',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
        name: 'dequeued',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
        name: 'emptyIndices',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'aNumerator', internalType: 'uint256', type: 'uint256' },
            { name: 'aDenominator', internalType: 'uint256', type: 'uint256' },
            { name: 'bNumerator', internalType: 'uint256', type: 'uint256' },
            { name: 'bDenominator', internalType: 'uint256', type: 'uint256' },
            { name: 'exponent', internalType: 'uint256', type: 'uint256' },
            { name: '_decimals', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'fractionMulExp',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'header', internalType: 'bytes', type: 'bytes' }],
        name: 'getBlockNumberFromHeader',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getEpochNumber',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'blockNumber', internalType: 'uint256', type: 'uint256' }],
        name: 'getEpochNumberOfBlock',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getEpochSize',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'blockNumber', internalType: 'uint256', type: 'uint256' }],
        name: 'getParentSealBitmap',
        outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'header', internalType: 'bytes', type: 'bytes' }],
        name: 'getVerifiedSealBitmapFromHeader',
        outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'header', internalType: 'bytes', type: 'bytes' }],
        name: 'hashHeader',
        outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'hotfixExecutionTimeWindow',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
        name: 'hotfixes',
        outputs: [
            { name: 'executed', internalType: 'bool', type: 'bool' },
            { name: 'approved', internalType: 'bool', type: 'bool' },
            { name: 'deprecated_preparedEpoch', internalType: 'uint256', type: 'uint256' },
            { name: 'councilApproved', internalType: 'bool', type: 'bool' },
            { name: 'executionTimeLimit', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'initialized',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'isOwner',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'lastDequeue',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'minDeposit',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'blockNumber', internalType: 'uint256', type: 'uint256' }],
        name: 'minQuorumSize',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'minQuorumSizeInCurrentSet',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'numberValidatorsInCurrentSet',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'blockNumber', internalType: 'uint256', type: 'uint256' }],
        name: 'numberValidatorsInSet',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'owner',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'proposalCount',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'queueExpiry',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: '', internalType: 'address', type: 'address' }],
        name: 'refundedDeposits',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'registry',
        outputs: [{ name: '', internalType: 'contract IRegistry', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'securityCouncil',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'registryAddress', internalType: 'address', type: 'address' }],
        name: 'setRegistry',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'stageDurations',
        outputs: [
            { name: 'approval', internalType: 'uint256', type: 'uint256' },
            { name: 'referendum', internalType: 'uint256', type: 'uint256' },
            { name: 'execution', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'index', internalType: 'uint256', type: 'uint256' }],
        name: 'validatorAddressFromCurrentSet',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'index', internalType: 'uint256', type: 'uint256' }],
        name: 'validatorSignerAddressFromCurrentSet',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'index', internalType: 'uint256', type: 'uint256' },
            { name: 'blockNumber', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'validatorSignerAddressFromSet',
        outputs: [{ name: '', internalType: 'address', type: 'address' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'registryAddress', internalType: 'address', type: 'address' },
            { name: '_approver', internalType: 'address', type: 'address' },
            { name: '_concurrentProposals', internalType: 'uint256', type: 'uint256' },
            { name: '_minDeposit', internalType: 'uint256', type: 'uint256' },
            { name: '_queueExpiry', internalType: 'uint256', type: 'uint256' },
            { name: '_dequeueFrequency', internalType: 'uint256', type: 'uint256' },
            { name: 'referendumStageDuration', internalType: 'uint256', type: 'uint256' },
            { name: 'executionStageDuration', internalType: 'uint256', type: 'uint256' },
            { name: 'participationBaseline', internalType: 'uint256', type: 'uint256' },
            { name: 'participationFloor', internalType: 'uint256', type: 'uint256' },
            { name: 'baselineUpdateFactor', internalType: 'uint256', type: 'uint256' },
            { name: 'baselineQuorumFactor', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'initialize',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'destination', internalType: 'address', type: 'address' },
            { name: 'functionId', internalType: 'bytes4', type: 'bytes4' },
            { name: 'threshold', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'setConstitution',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_council', internalType: 'address', type: 'address' }],
        name: 'setSecurityCouncil',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'timeWindow', internalType: 'uint256', type: 'uint256' }],
        name: 'setHotfixExecutionTimeWindow',
        outputs: [],
    },
    {
        constant: false,
        payable: true,
        stateMutability: 'payable',
        type: 'function',
        inputs: [
            { name: 'values', internalType: 'uint256[]', type: 'uint256[]' },
            { name: 'destinations', internalType: 'address[]', type: 'address[]' },
            { name: 'data', internalType: 'bytes', type: 'bytes' },
            { name: 'dataLengths', internalType: 'uint256[]', type: 'uint256[]' },
            { name: 'descriptionUrl', internalType: 'string', type: 'string' },
        ],
        name: 'propose',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256' },
            { name: 'lesser', internalType: 'uint256', type: 'uint256' },
            { name: 'greater', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'upvote',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'lesser', internalType: 'uint256', type: 'uint256' },
            { name: 'greater', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'revokeUpvote',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'approve',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
            { name: 'value', internalType: 'enum Proposals.VoteValue', type: 'uint8' },
        ],
        name: 'vote',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
            { name: 'yesVotes', internalType: 'uint256', type: 'uint256' },
            { name: 'noVotes', internalType: 'uint256', type: 'uint256' },
            { name: 'abstainVotes', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'votePartially',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'revokeVotes',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'execute',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'hash', internalType: 'bytes32', type: 'bytes32' }],
        name: 'approveHotfix',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'hash', internalType: 'bytes32', type: 'bytes32' }],
        name: 'whitelistHotfix',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'hash', internalType: 'bytes32', type: 'bytes32' }],
        name: 'prepareHotfix',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'values', internalType: 'uint256[]', type: 'uint256[]' },
            { name: 'destinations', internalType: 'address[]', type: 'address[]' },
            { name: 'data', internalType: 'bytes', type: 'bytes' },
            { name: 'dataLengths', internalType: 'uint256[]', type: 'uint256[]' },
            { name: 'salt', internalType: 'bytes32', type: 'bytes32' },
        ],
        name: 'executeHotfix',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'withdraw',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
        name: 'isProposalPassing',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'isDequeuedProposal',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
        name: 'isDequeuedProposalExpired',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'destination', internalType: 'address', type: 'address' },
            { name: 'functionId', internalType: 'bytes4', type: 'bytes4' },
        ],
        name: 'getConstitution',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
        name: 'isVoting',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getReferendumStageDuration',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getExecutionStageDuration',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getParticipationParameters',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
        name: 'proposalExists',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
        name: 'getProposal',
        outputs: [
            { name: '', internalType: 'address', type: 'address' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'string', type: 'string' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'bool', type: 'bool' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'proposalId', internalType: 'uint256', type: 'uint256' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'getProposalTransaction',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'address', type: 'address' },
            { name: '', internalType: 'bytes', type: 'bytes' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
        name: 'isApproved',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
        name: 'getVoteTotals',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'account', internalType: 'address', type: 'address' },
            { name: 'index', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'getVoteRecord',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getQueueLength',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
        name: 'getUpvotes',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getQueue',
        outputs: [
            { name: '', internalType: 'uint256[]', type: 'uint256[]' },
            { name: '', internalType: 'uint256[]', type: 'uint256[]' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [],
        name: 'getDequeue',
        outputs: [{ name: '', internalType: 'uint256[]', type: 'uint256[]' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
        name: 'getUpvoteRecord',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
        name: 'getMostRecentReferendumProposal',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
        name: 'getProposalStage',
        outputs: [{ name: '', internalType: 'enum Proposals.Stage', type: 'uint8' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'pure',
        type: 'function',
        inputs: [],
        name: 'getVersionNumber',
        outputs: [
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'pure',
        type: 'function',
        inputs: [
            { name: 'values', internalType: 'uint256[]', type: 'uint256[]' },
            { name: 'destinations', internalType: 'address[]', type: 'address[]' },
            { name: 'data', internalType: 'bytes', type: 'bytes' },
            { name: 'dataLengths', internalType: 'uint256[]', type: 'uint256[]' },
            { name: 'salt', internalType: 'bytes32', type: 'bytes32' },
        ],
        name: 'getHotfixHash',
        outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_approver', internalType: 'address', type: 'address' }],
        name: 'setApprover',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_concurrentProposals', internalType: 'uint256', type: 'uint256' }],
        name: 'setConcurrentProposals',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_minDeposit', internalType: 'uint256', type: 'uint256' }],
        name: 'setMinDeposit',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_queueExpiry', internalType: 'uint256', type: 'uint256' }],
        name: 'setQueueExpiry',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: '_dequeueFrequency', internalType: 'uint256', type: 'uint256' }],
        name: 'setDequeueFrequency',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'referendumStageDuration', internalType: 'uint256', type: 'uint256' }],
        name: 'setReferendumStageDuration',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'executionStageDuration', internalType: 'uint256', type: 'uint256' }],
        name: 'setExecutionStageDuration',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'participationBaseline', internalType: 'uint256', type: 'uint256' }],
        name: 'setParticipationBaseline',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'participationFloor', internalType: 'uint256', type: 'uint256' }],
        name: 'setParticipationFloor',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'baselineUpdateFactor', internalType: 'uint256', type: 'uint256' }],
        name: 'setBaselineUpdateFactor',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'baselineQuorumFactor', internalType: 'uint256', type: 'uint256' }],
        name: 'setBaselineQuorumFactor',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [],
        name: 'dequeueProposalsIfReady',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [
            { name: 'account', internalType: 'address', type: 'address' },
            { name: 'newVotingPower', internalType: 'uint256', type: 'uint256' },
        ],
        name: 'removeVotesWhenRevokingDelegatedVotes',
        outputs: [],
    },
    {
        constant: false,
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
        inputs: [{ name: 'hash', internalType: 'bytes32', type: 'bytes32' }],
        name: 'resetHotFixRecord',
        outputs: [],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'hash', internalType: 'bytes32', type: 'bytes32' }],
        name: 'hotfixWhitelistValidatorTally',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'hash', internalType: 'bytes32', type: 'bytes32' }],
        name: 'isHotfixPassing',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'hash', internalType: 'bytes32', type: 'bytes32' }],
        name: 'getL1HotfixRecord',
        outputs: [
            { name: '', internalType: 'bool', type: 'bool' },
            { name: '', internalType: 'bool', type: 'bool' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'hash', internalType: 'bytes32', type: 'bytes32' }],
        name: 'getHotfixRecord',
        outputs: [
            { name: '', internalType: 'bool', type: 'bool' },
            { name: '', internalType: 'bool', type: 'bool' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'hash', internalType: 'bytes32', type: 'bytes32' }],
        name: 'getL2HotfixRecord',
        outputs: [
            { name: '', internalType: 'bool', type: 'bool' },
            { name: '', internalType: 'bool', type: 'bool' },
            { name: '', internalType: 'bool', type: 'bool' },
            { name: '', internalType: 'uint256', type: 'uint256' },
        ],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
        name: 'isQueued',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [
            { name: 'hash', internalType: 'bytes32', type: 'bytes32' },
            { name: 'whitelister', internalType: 'address', type: 'address' },
        ],
        name: 'isHotfixWhitelistedBy',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
        name: 'isQueuedProposalExpired',
        outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    },
    {
        constant: true,
        payable: false,
        stateMutability: 'view',
        type: 'function',
        inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
        name: 'getAmountOfGoldUsedForVoting',
        outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    },
];
